// ─────────────────────────────────────────────────────────────────────────────
// Service Worker Registrierung (FEAT-021)
//
// Wird einmal aus index.tsx aufgerufen. Registriert den SW unter /service-worker.js
// und löst ein Update aus wenn der Code geändert wurde.
//
// Wichtig: Nur in production registrieren – im dev-Server würde der SW
// cached und Hot-Reload verhindern.
// ─────────────────────────────────────────────────────────────────────────────

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  // Im Dev-Modus überspringen
  if (process.env.NODE_ENV !== 'production') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        // Periodisch nach Updates schauen (alle 60 Min)
        setInterval(() => registration.update().catch(() => {/* ignore */}), 60 * 60 * 1000);
      })
      .catch((err) => {
        console.warn('Service Worker-Registrierung fehlgeschlagen:', err);
      });
  });
}

// Hilfsfunktion: aktive Subscription holen (für Push-Permission-Check)
export async function getPushSubscription(): Promise<PushSubscription | null> {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.ready;
    return await reg.pushManager.getSubscription();
  } catch {
    return null;
  }
}
